<template>
  <el-form label-position="top" :model="form" :rules="rules" ref="form_create">
    <!-- <h2 class="title">Nuevo documento</h2> -->

    <el-form-item
      style="margin-top: 30px; font-weight: bold"
      label="Categoría de Documento"
      prop="DocumentCategoryId"
    >
      <el-select
        v-model="form.DocumentCategoryId"
        placeholder="Seleccione una Categoría"
        filterable
      >
        <el-option
          v-for="item in categoriesValue"
          :key="item.ID"
          :value="item.ID"
          :label="item.Name"
        >
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="Adjuntar documento" style="font-weight: bold">
      <el-upload
        ref="uploadFile"
        class="upload-demo"
        action="/api/ISODocuments/UploadFile"
        :drag="true"
        :auto-upload="false"
        :multiple="true"
        :on-success="handleUploadOnSuccess"
        :file-list="fileList"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          Suelta tu archivo aquí o <em>haz clic para cargar</em>
        </div>
        <div slot="tip" class="el-upload__tip">
          Solo archivos con un tamaño menor de 26MB
        </div>
      </el-upload>
    </el-form-item>
    <el-button @click="onCancel" size="mini">Cancel</el-button>
    <el-button id="btnSave" type="primary" size="mini" @click="saveDocument"
      >Guardar</el-button
    >
  </el-form>
</template>

<script>
import MixinDocumment from "@/components/MixinUploadDocument.vue";

export default {
  name: "NewDocument",
  mixins: [MixinDocumment],
  created() {
    this.form.UserId = this.currentUser.UserID;
    this.getCategories();
  },
  data() {
    return {
      fileList: [],
      form: {
        DocumentCategoryId: "",
        UserId: 0,
        DocumentURLs: []
      },
      rules: {
        DocumentCategoryId: [
          { required: true, trigger: "blur", message: "Requerido" }
        ]
      },
      categoriesValue: "",
      postUrl: "/api/ISODocuments/Create",
      successMessage: "Creado de iso"
    };
  },
  methods: {
    getCategories() {
      this.$http
        .get("/api/ISODocumentCategory")
        .then((resp) => {
          const IsoCat = resp.data.Items.map((i) => {
            return { ID: i.Id, Name: i.Name };
          });
          this.categoriesValue = IsoCat;
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    handleUploadOnSuccess(response) {
      const items_count = response.length;
      for (var index = 0; index < items_count; index++) {
        this.form.DocumentURLs.push(response[index]);
      }
      this.count++;
    },
    onCancel() {
      this.fileList = [];
      this.form = {
        DocumentCategoryId: 0,
        UserId: 0,
        DocumentURLs: []
      };
      this.$emit("dialog-closed");
      this.$refs.form_create.resetFields();
    }
  }
};
</script>
